<template>
  <div class="collect-page collect-card">
    <div class="mains-content">
      <div class="page-left">
        <div class="member-box">
          <member ref="memberSearch" :mobile="formMobile" @handleChange="memberChange"></member>
        </div>
        <div class="right-box">
          <div v-if="listSelected.length == 0 ? true : false" class="right-box-empty">
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/fooBath_empty.png" alt="">
            </div>
          </div>
          <div v-else>
            <p class="shoping-titles">消费明细</p>
            <div class="contents-body">
              <el-row class="tables-title">
                <el-col :span="8" class="titles">
                  <div class="goodName">商品名称</div>
                </el-col>
                <el-col :span="5" class="titles center">原价</el-col>
                <el-col :span="5" class="titles center">数量</el-col>
                <el-col :span="3" class="titles center">小计</el-col>
                <el-col :span="3" class="titles right">操作</el-col>
              </el-row>
              <div class="tables p30 scroll-auto">
                <div class="boxs" v-for="(item, index) in listSelected" :key="index">
                  <el-row>
                    <el-col :span="8" class="titles ">
                      <div class="goodName fb">{{
                        item.name
                      }}</div>
                    </el-col>
                    <el-col :span="5" class="center fb">
                      {{ item.salePrice }}

                    </el-col>
                    <el-col :span="5" class="nums center">
                      1
                    </el-col>
                    <el-col :span="3" class="titles center fb fontSize18">{{ item.salePrice }}</el-col>
                    <el-col :span="3" class="detail right">
                      <i class="el-icon-delete delete" @click="deleteListSelected(item, index)"></i>
                    </el-col>
                  </el-row>
                  <div class="right-content p10">
                    <span class="color666 fontSize16 mr10">服务技师 :</span>
                    <span v-if="item.staffIds.length == 0" @click="setStaff(item, index)" class="shopClass">请选择></span>
                    <span v-else @click="setStaff(item, index)" class="shopClass">{{ staffName }}</span>
                  </div>
                </div>
              </div>
              <div class="confirm-btn">
                <div class="flex-row space-between">
                  <div class="msg">
                    <div class="nums total">
                      总数量:
                      <span>1</span>
                    </div>
                    <div class="total">
                      总金额:
                      <span class="moneys fontSize20">￥<span class="fontSize28 fb">{{ totalAmount }}</span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button class="save_btn" @click="saveMoney">确定开单</el-button>
      </div>
      <div class="left-box br10">
        <el-tabs v-model="active" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in allList" :key="index" :label="item.name"
            :name="item.cardType"></el-tab-pane>
        </el-tabs>
        <div style="display: flex;width: 60%;" class="mb10 ml20">
          <el-input v-model="value" placeholder="请输入商品名称" clearable @keyup.enter.native="filterData" @clear="clearGoods"></el-input>
          <el-button type="primary" class="ml10" @click="filterData">搜索</el-button>
          <el-button type="default" class="ml10" @click="clearGoods">清空</el-button>
        </div>
        <!-- 历史记录 -->
        <div class="history ml20" style="display: flex;font-size: 14px;color: #333;cursor: pointer;">
            <div v-for="i, idx in numberHistoryList" :key="idx" class="mr20" @mousedown.prevent="chooseName(i)">
              <span>{{ i }}</span>
              <i class="el-icon-error" style="margin-left: 5px;" @mousedown.stop="removeTag(i)"></i>
            </div>
        </div>
        <div class="card-all scroll-auto" :class="[allList.length > 0 ? 'box-active' : '']" v-if="list && list.length != 0">
          <div class="title-tabs">
            <div class="card-box" v-for="(item, index) in list" :key="index" :class="{ 'box-actives': item.flag }">
              <div @click="handleChangeList(item, index)">
                <div class="card-msg active">
                  <div class="flex-row space-between block">
                    <p class="card-name">{{ item.name }}</p>
                    <img src="../../../assets/images/new/memberCard_selected.png" v-if="item.flag" alt=""
                      class="card_active">
                  </div>
                  <div class="flex-msg">
                    <p class="money block">￥{{ item.salePrice }}</p>
                  </div>
                  <div class="msg block space-between" style="color: #999;">
                    <p>{{ item.duration == -1 ? "永久有效" : "有效天数" + item.duration + "天" }}</p>
                    <p class="msg" v-if="active == 'number'">有效次数<span class="money">{{ item.useNum }}</span>次</p>
                    <p v-if="active == 'groupCard'" class="jishi cur" @click.stop="cardInfo(item)">套餐详情<i
                        class="el-icon-arrow-right"></i></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-all scroll-auto cardFlex" v-if="list && list.length == 0">
          暂无数据
        </div>
        <tips :type="'member'" class="tips-position"></tips>
      </div>

    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="30%" class="groupDialog" :close-on-click-modal='false'>
      <div slot="title" class="fontSize18 fb">{{ groupCardInfo.cardName }}</div>
      <div>
        <div v-if="groupCardInfo.cardRightsBaseList && groupCardInfo.cardRightsBaseList.length != 0">
          <!-- <p class="allColors"></p> -->
          <el-row>
            <el-col :span="14" class="fontSize16 fb">主项目</el-col>
            <el-col :span="6" class="fontSize16 fb">单价</el-col>
            <el-col :span="4" class="divRight fontSize16 fb">数量</el-col>
          </el-row>
          <el-row v-for="item in groupCardInfo.cardRightsBaseList" :key="item.id" class="mt20">
            <el-col :span="14">{{ item.itemName }}</el-col>
            <el-col :span="6" class="moneys">￥{{ item.itemPrice }}</el-col>
            <el-col :span="4" class="divRight">x{{ item.ruleValue }}</el-col>
          </el-row>
        </div>
        <div v-if="groupCardInfo.cardRightsBaseList && groupCardInfo.cardRightsGiveList.length != 0" class="mt30">
          <el-row>
            <el-col :span="14" class="fontSize16 fb">赠送项目</el-col>
            <el-col :span="6" class="fontSize16 fb">单价</el-col>
            <el-col :span="4" class="divRight fontSize16 fb">数量</el-col>
          </el-row>
          <el-row v-for="item in groupCardInfo.cardRightsGiveList" :key="item.id" class="mt20">
            <el-col :span="14">{{ item.itemName }}</el-col>
            <el-col :span="6" class="moneys">￥{{ item.itemPrice }}</el-col>
            <el-col :span="4" class="divRight">x{{ item.ruleValue }}</el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
    <pay-success ref="paySuccessForm" :source="sourceActive" :isMeal="active" @change="backChange"></pay-success>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import staffSet from "../../components/staff-set";
import member from "../../components/member";
import paySuccess from "../../components/pay-success";
import tips from "../../../components/tips";
export default {
  mixins: [minxin],
  components: { staffSet, member, paySuccess, tips },
  data() {
    return {
      value:'',
      index:0,
      totalAmount: 0,
      list: [],
      listSelected: [],
      formMobile: "",
      staffName: "",
      form: {
        memberId: "",
        orderId: "",
        staffIds: "",
        orderItemList: []
      },
      active: "",
      allList: [],
      centerDialogVisible: false,
      groupCardInfo: {},
      sourceActive: "openCard",
      showHistory: false,
      numberHistoryList: []
    };
  },
  watch: {
    listSelected() {
      this.totalAmount = 0;
      for (let i in this.listSelected) {
        this.totalAmount = this.listSelected[i].salePrice;
      }
    }
  },
  created() {
    this.serveList();
    if (JSON.parse(localStorage.getItem("goodsHistoryList"))) {
      this.numberHistoryList = JSON.parse(localStorage.getItem("goodsHistoryList")) || [];
    }
  },
  mounted() {

  },
  destroyed() {
    localStorage.removeItem("orderId")
  },
  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    backChange(org) {
      if (org) {
        this.staffName = "";
        this.listSelected = [];
        this.form = {
          memberId: "",
          orderId: "",
          staffIds: "",
          orderItemList: []
        };
        this.list.map(item => {
          item.flag = false;
        })
        this.$refs.memberSearch.handleInputHide();
      }
    },
    cardInfo(item) {
      // 套餐详情
      this.centerDialogVisible = true;
      this.$api.get(this.$url.card.listCardRight, { cardId: item.id }).then(res => {
        if (res) {
          this.groupCardInfo = res;
        }
      });

    },
    memberChange(value) {
      if (value == "") {
        for (let i in this.list) {
          this.$set(this.list[i], "flag", false);
          this.$set(this.list[i], "staffIds", []);
        }
        this.listSelected = [];
      }
      this.form.memberId = value;

    },
    handleChangeList(item) {
      this.listSelected = [];
      this.allList.map(it => {
        it.cardList.map(ind => {
          ind.flag = false;
        })
      })
      item.flag = true;
      this.listSelected.push(JSON.parse(JSON.stringify(item)));
    },
    deleteListSelected(item, index) {
      this.list.map(it => {
        it.flag = false
      })
      this.listSelected.splice(index, 1);
      item.staffIds = []
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: row.staffIds,
        index: index
      });
    },
    changePage(org) {
      if (org.staffIds) {
        let arr = []
        org.staffIds.map(item => {
          arr.push(item.staffName)
        })
        this.staffName = arr.join(",") + ">";
        console.log(this.staffName);
        this.$set(this.listSelected[org.nodeId], "staffIds", org.staffIds);
      }
    },
    handleClick(item) {
      this.active = item.name;
      this.index = item.index
      this.value = ''
      if (item.index == 0) {
        this.list = this.allList[0].cardList || [];
          for (let i in this.list) {
            this.$set(this.list[i], "staffIds", []);
          }
      } else if (item.index == 1) {
        this.list = this.allList[1].cardList || [];
        for (let i in this.list) {
          this.$set(this.list[i], "staffIds", []);
        }
      } else if (item.index == 2) {
        this.list = this.allList[2].cardList || []
        for (let i in this.list) {
          this.$set(this.list[i], "staffIds", []);
        }
      }
    },

    saveMoney() {
      if (this.form.memberId == "") {
        this.$message.warning("请选择会员");
        return false;
      }
      if (this.listSelected.length < 1) {
        this.$message.warning("请添加消费");
        return false;
      }
      for (let i in this.listSelected) {
        if (this.listSelected[i].staffIds.length < 1) {
          this.$message.warning(this.listSelected[i].name + " 请选择技师");
          return false;
        }
      }
      if (this.active != 'discount') return this.saveFunction()
      this.$api.get(this.$url.card.checkDiscountCard, {
        memberId: this.form.memberId
      }).then(res => {
        if (res) {
          const h = this.$createElement;
          this.$msgbox({
            title: '',
            message: h('p', null, [h('div', `当前会员已绑定${res}`), h('div', "继续操作将覆盖原折扣卡")]),
            showCancelButton: true,
            confirmButtonText: '继续开卡',
            cancelButtonText: '取消',
            center: true
          }).then(action => {
            this.saveFunction();
          });
        } else {
          this.saveFunction();
        }
      });

    },

    saveFunction() {
      this.form.orderItemList = this.listSelected;
      let arrIds = "",
        arrNames = "",
        obj = [];
      for (let i in this.form.orderItemList) {
        for (let j in this.form.orderItemList[i].staffIds) {
          if (j == 0) {
            arrIds = this.form.orderItemList[i].staffIds[j].staffId;
            arrNames = this.form.orderItemList[i].staffIds[j].staffName;
          } else {
            arrIds += "," + this.form.orderItemList[i].staffIds[j].staffId;
            arrNames += "," + this.form.orderItemList[i].staffIds[j].staffName;
          }
        }
        this.form.itemId = this.form.orderItemList[i].id;
        this.form.itemName = this.form.orderItemList[i].name;
        this.form.staffIds = arrIds;
        this.form.staffNames = arrNames;
        this.form.sourceFrom = "card";
        obj.push({
          itemId: this.form.orderItemList[i].id,
          itemType: 'card',
          itemName: this.form.orderItemList[i].name,
          itemNum: this.form.orderItemList[i].itemNum ? this.form.orderItemList[i].itemNum : 1,
          salePrice: this.form.orderItemList[i].salePrice,
          staffIds: arrIds,
          staffNames: arrNames
        });
      }
      this.form.orderItemList = obj;
      if (!this.form.repeatToken) {
        this.$api.get(this.$url.order.getToken).then(res => {
          if (res) {
            this.form.repeatToken = res;
            this.$refs["paySuccessForm"].$emit("set", this.form);
          }
        })
      } else {
        this.$refs["paySuccessForm"].$emit("set", this.form);
      }
      this.form.staffIds = arrIds;
    },

    serveList() {
      this.$api.post(this.$url.card.listByCateTree, { size: 500 }).then(res => {
        if (res) {
          this.list = res.length > 0 ? res[0].cardList : [];
          this.allList = res;
          if (res.length > 0) {
            this.active = res[0].cardType;
          }
          for (let i in this.list) {
            this.$set(this.list[i], "staffIds", []);
          }
        }
      });
    },
    filterData() {
      console.log(this.allList);
      console.log(this.index);
      this.list = this.allList[this.index].cardList || []
      for(let i in this.list){
        this.$set(this.list[i],"staffIds",[])
      }
      if (this.value) {
        this.boxList = this.fuzzyQuery(this.list, this.value);
        this.list = this.boxList
        this.setHistoryList()
      }
    },
    setHistoryList () {
      if (this.numberHistoryList.includes(this.value)) {
        this.numberHistoryList = this.numberHistoryList.filter((item) => {
            return item !== this.value
        });
        this.numberHistoryList.unshift(this.value);
        localStorage.setItem("goodsHistoryList", JSON.stringify(this.numberHistoryList));
        return;
      }
      if (this.numberHistoryList.length >= 3) {
        this.numberHistoryList.pop()
      }
      this.numberHistoryList.unshift(this.value);
      localStorage.setItem("goodsHistoryList", JSON.stringify(this.numberHistoryList));
    },
    fuzzyQuery(list, keyWord) {
      var reg = new RegExp(keyWord);
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].name)) {
          arr.push(list[i]);
        }
      }
      return arr;
    },
    clearGoods() {
      this.value = ''
      this.list = this.allList[this.index].cardList || []
      for(let i in this.list){
        this.$set(this.list[i],"staffIds",[])
      }
    },
    chooseName(item) {
      this.list = this.allList[this.index].cardList || []
      for(let i in this.list){
        this.$set(this.list[i],"staffIds",[])
      }
      this.value = item
      this.boxList = this.fuzzyQuery(this.list, this.value);
      this.list = this.boxList
      this.setHistoryList()
    },
    removeTag(item) {
      let idx = this.numberHistoryList.indexOf(item)
      if (idx != -1) {
        this.numberHistoryList.splice(idx, 1)
        localStorage.setItem("goodsHistoryList", JSON.stringify(this.numberHistoryList));
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

.block {
  width: 100%;

  .card_active {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
  }
}

.cardFlex {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}

/deep/ .el-tabs__nav-wrap {
  padding: 0 16px;

  .el-tabs__item {
    height: 48px;
    line-height: 48px;
    font-size: 18px;
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #F5F5F5;
}

.mains-content {
  display: flex;
  height: 100%;

  .left-box {
    width: 60%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    .tips-position {
      position: absolute;
      width: calc(100% - 74px);
      bottom: 16px;
    }

    .card-all {
      height: 100%;

      .title-tabs {
        display: flex;
        flex-wrap: wrap;
        padding: 15px 25px;
      }
    }

    .card-box {
      width: calc(32% - 38px);
      height: 132px;
      padding: 16px;
      margin-right: 2%;
      margin-bottom: 20px;
      background: url("../../../assets/images/new/memberCard.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      border: 1px solid #FEE7D5;

      &:nth-of-type(3n) {
        margin-right: 0;
      }

      .card-msg {
        .flex-msg {
          font-size: 18px;
          font-weight: 700;
          padding: 40px 0 20px 0;
        }

        .card-name {
          font-size: 18px;
          font-weight: 700;
        }

        .msg {
          text-align: left;
        }
      }

      .active {
        color: #333;

        .money {
          color: @money;
        }
      }
    }
  }
}

.collect-card {
  height: calc(100vh - 58px);
  background-color: #e6edf5;
  padding: 16px;

  .groupDialog /deep/ .el-dialog__body {
    padding: 10px 20px;
    color: #111;
    height: 200px;
    overflow: auto;
  }
}

.box-active {
  height: 435px !important;
}

.member-box {
  width: calc(100% - 48px);
  padding: 15px 16px;
  background: #3388ff;
  border-radius: 10px 10px 0px 0px;
}

.right-box {
  background: url("../../../assets/images/new/footBath.png") no-repeat;
  background-position: center bottom;
  height: calc(100vh - 248px);
  margin-right: 16px;

  .right-box-empty {
    height: calc(100vh - 248px);
    display: flex;
    justify-content: center;
    align-items: center;

    .right-box-empty-img {
      width: 191px;
      height: 170px;
    }
  }

  .shoping-titles {
    padding: 16px;
    font-size: 18px;
    font-weight: 700;
  }

  .contents-body {
    .tables-title {
      padding: 13px 16px;
      font-size: 14px;
      background: #F7F8FA;
    }

    .tables {
      padding: 0 0 16px;
      height: calc(100vh - 430px);
      box-sizing: border-box;

      .boxs {
        padding: 18px 16px 0;
        box-sizing: border-box;

        .money {
          color: @money;
          font-weight: 500;
        }

        .delete {
          font-size: 18px;
          cursor: pointer;

          &:hover {
            color: @blue;
          }
        }
      }

      .right-content {
        margin-top: 15px;
        display: flex;
        padding-bottom: 16px;
        border-bottom: 1px solid #EBEDF0;
      }
    }

    .confirm-btn {
      display: flex;
      align-items: center;
      margin: 0 16px;
      border-top: 1px solid #EBEDF0;
      padding: 12px 0;

      .flex-row {
        width: 100%;
        align-items: center;

        .msg {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          font-weight: 500;

          .nums {
            line-height: 3;
            margin-right: 40px;
          }
        }
      }
    }

  }

}

.page-left {
  width: 40%;
}

.box-actives {
  border: 1px solid #F9AA6C !important;
}

.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #FF5449;
}

.goodName {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}</style>
